module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0113.jpg?v=d7660e86";